module.exports = __webpack_public_path__ + "img/logo.097569b3.png";